import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../components/Loader";

const withCustomAuthenticationRequired = (
    Component,
    options = {}
) => {
    return function Protected(props) {

        const {
            isAuthenticated,
            isLoading
        } = useAuth0();

        if (isLoading) {
            return options.onRedirecting
                ? options.onRedirecting()
                : <Loader />;
        }

        if (!isAuthenticated) {

            sessionStorage.setItem(
                "returnTo",
                window.location.pathname +
                window.location.search
            );

            window.location.href = "/login";

            return null;
        }

        return <Component {...props} />;
    };
};

export default withCustomAuthenticationRequired;